!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports) : "function" == typeof define && define.amd ? define(["exports"], r) : r((e = e || self).cssModulesThemeCore = {});
}(this, function (e) {
  "use strict";

  function r() {
    return (r = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var o = arguments[r];
        for (var n in o) {
          Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
        }
      }
      return e;
    }).apply(this, arguments);
  }
  function o(e, r) {
    var o = r.length,
      n = {};
    for (var i in e) {
      e.hasOwnProperty(i) && 0 === i.indexOf(r) && (n[i.substr(o)] = e[i]);
    }
    return n;
  }
  function n(e) {
    var r = Object.create(null),
      o = !1;
    for (var n in e) {
      if (e.hasOwnProperty(n)) {
        var i = " " + e[n] + " ";
        for (var t in e) {
          e.hasOwnProperty(t) && t !== n && -1 !== (e[t] + " ").indexOf(i) && (void 0 === r[n] ? (o = !0, r[n] = [t]) : r[n].push(t));
        }
      }
    }
    if (o) return r;
  }
  var i;
  (i = e.Compose || (e.Compose = {})).Merge = "merge", i.Assign = "assign", i.Replace = "replace";
  var t = new WeakMap(),
    a = new WeakMap(),
    s = new WeakMap(),
    f = function f(e, r) {
      var n,
        i = a.get(e);
      return void 0 === i ? (i = [], a.set(e, i)) : n = i.find(function (o) {
        return o.theme === e && o.prefix === r;
      }), void 0 === n && (n = {
        theme: e,
        prefix: r,
        finalTheme: o(e, r)
      }, i.push(n)), n.finalTheme;
    },
    p = function p(e) {
      var r = s.get(e);
      return void 0 === r && void 0 !== (r = n(e)) && s.set(e, r), r;
    };
  e.composeTheme = function (i) {
    var a,
      s,
      v = i[0],
      h = !0 !== v.noCache,
      m = "string" == typeof v.compose ? v.compose : e.Compose.Merge;
    a = "string" == typeof v.prefix && v.prefix.length > 0 ? f(v.theme, v.prefix) : v.theme;
    for (var c = function c(_c) {
        var d = i[_c],
          u = d.theme,
          l = d.prefix,
          g = d.compose,
          y = d.noParseComposes,
          x = d.noCache,
          C = void 0 !== x && x,
          b = "boolean" == typeof y ? !1 === y : !0 !== v.noParseComposes;
        "string" == typeof g && (m = g), C && h && (h = !1);
        var O = void 0;
        if (h && m !== e.Compose.Replace) {
          var T = t.get(u);
          if (void 0 === T) T = [], t.set(u, T);else if (void 0 !== (O = T.find(function (e) {
            return e.againstTheme === a && e.prefix === l && e.composeMethod === m && e.parseComposes === b;
          }))) return a = O.composedTheme, "continue";
          O = {
            againstTheme: a,
            prefix: l,
            composeMethod: m,
            parseComposes: b
          }, T.push(O);
        }
        var w = void 0;
        if (w = "string" == typeof l && l.length > 0 ? (C ? o : f)(u, l) : u, m === e.Compose.Replace) return a = w, b && _c < i.length - 1 && (s = h ? p(a) : n(a)), "continue";
        if (1 === _c && !0 !== y && (s = h ? p(v.theme) : n(v.theme)), m === e.Compose.Merge) {
          var P = w;
          for (var M in w = r({}, a), P) {
            if (P.hasOwnProperty(M)) {
              var k = w[M],
                A = P[M];
              if (void 0 !== k && (A = k + " " + A, !0 === b && void 0 !== s && void 0 !== s[M])) {
                var j = new RegExp("\\b" + k + "\\b"),
                  R = s[M],
                  W = Array.isArray(R),
                  D = 0;
                for (R = W ? R : R[Symbol.iterator]();;) {
                  var E;
                  if (W) {
                    if (D >= R.length) break;
                    E = R[D++];
                  } else {
                    if ((D = R.next()).done) break;
                    E = D.value;
                  }
                  var S = E;
                  w[S] = w[S].replace(j, A);
                }
              }
              w[M] = A;
            }
          }
        } else if (m === e.Compose.Assign) if (void 0 === s || !1 === b) w = r({}, a, {}, w);else {
          var _ = w;
          for (var q in w = r({}, a), _) {
            if (_.hasOwnProperty(q)) {
              var z = w[q],
                B = _[q];
              if (void 0 !== s[q]) {
                var F = new RegExp("\\b" + z + "\\b"),
                  G = s[q],
                  H = Array.isArray(G),
                  I = 0;
                for (G = H ? G : G[Symbol.iterator]();;) {
                  var J;
                  if (H) {
                    if (I >= G.length) break;
                    J = G[I++];
                  } else {
                    if ((I = G.next()).done) break;
                    J = I.value;
                  }
                  var K = J;
                  w[K] = w[K].replace(F, B);
                }
              }
              w[q] = B;
            }
          }
        }
        void 0 !== O && (O.composedTheme = w), a = w;
      }, d = 1; d < i.length; d++) {
      c(d);
    }
    return a;
  }, e.filterThemeWithPrefix = o, e.getCachedPrefixedTheme = f, e.getCachedThemeCompositionDependencies = p, e.getThemeCompositionDependencies = n, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});